/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import Axios from "axios";
import {
  create,
  getAll,  
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import { useDelete } from "../../../../utils/hooks/useDelete";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { produce } from "immer";
import { requiredInputs } from "../../../../utils/constants";
import { ROUTES } from "../../../../utils/routes";
import { useSelector } from "react-redux";
import { IStore } from "../../../../interfaces/IStore";
import { IUser } from "../../../../interfaces/IUser";
import { IAmbito } from "../../../../interfaces/IAmbito";
// import { validate } from './validations';

export const ManageAmbitos: FC = () => {
  let { isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );

  const { id }: any = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { INVESTIGATORS, AMBITOS } = paths;

  const [isCreate, setIsCreate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //Group form
  const [tituloEs, setTituloEs] = useState("");
  const [tituloEn, setTituloEn] = useState("");
  const [tituloVa, setTituloVa] = useState("");

  const [image, setImage] = useState();
  const [descripcionEs, setDescripcionEs] = useState("");
  const [descripcionEn, setDescripcionEn] = useState("");
  const [descripcionVa, setDescripcionVa] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [staff, setStaff] = useState<any[]>([]);
  // const [chosenStaff, setChosenStaff] = useState<any[]>([]);

  const [message, setMessage] = useState("");

  const [allowedEdit, setAllowedEdit] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    checkIfIsEdit();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const checkIfIsEdit = () => {
    const { pathname }: any = history.location;
    if (pathname.includes("crear")) {
      setIsCreate(true);
      loadDefaultData(true);
    } else {
      loadDefaultData(false);
      setIsCreate(false);
    }
  };

  const loadDefaultData = async (isCreate: boolean) => {
    try {
      let staff = await getAll(INVESTIGATORS, source);

      if (isMountedRef.current) {
        setStaff(staff);
        if (!isCreate) {
          loadAmbito();
        } else setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadAmbito = async () => {
    try {
      const {
        tituloEs,
        tituloEn,
        tituloVa,
        staff,
        descripcionEs,
        descripcionEn,
        descripcionVa,
        videoUrl,
        image,
      } = await getById(AMBITOS, id, source);

      if (isMountedRef.current) {
        setTituloEs(tituloEs);
        setTituloEn(tituloEn);
        setTituloVa(tituloVa);
        setDescripcionEs(descripcionEs);
        setDescripcionEn(descripcionEn);
        setDescripcionVa(descripcionVa);
        setVideoUrl(videoUrl);
        setImage(image);
        // setChosenStaff(staff);
        // newStaff(staff, staff);

        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  // const newStaff = (u: any[], staff: any[]) => {
  //   // eslint-disable-next-line array-callback-return
  //   u.map((r: any) => {
  //     setStaff((state) =>
  //       produce(state, (drafState) => drafState.filter(({ id }) => id !== r.id))
  //     );
  //   });
  // };


  const handleSubmit = () => {
    // const staffIds = selectStaffIds();
    const ambito: IAmbito = buildAmbito();
    //  const notValid = validate(ambito);
    // 	if (notValid) {
    // 		setMessage(notValid);
    // 		setTimeout(() => setMessage(''), 4000);
    // 		return;
    // 	}

    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} ámbito?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(ambito, image);
    });
  };

  const handleConfirmation = (ambito: IAmbito, image: any) => {
    let createOrUpdate = isCreate
      ? create(AMBITOS, ambito, source)
      : update(AMBITOS, id, ambito, source);
    createOrUpdate
      .then(async ({ id: ambitoId }) => {
        let createOrUpdateText = isCreate ? "creado" : "editado";
        Swal.fire({
          icon: "success",
          text: `Ámbito ${createOrUpdateText} correctamente.`,
        });
        if (typeof image !== "string") {
          const formData = new FormData();
          formData.append("image", image!);
          await saveFile(AMBITOS, ambitoId, "image", formData, source);
        }
        history.push(`${ROUTES.Ambitos.all}/${ambitoId}`);
        isMountedRef.current && setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const buildAmbito = () => ({
    tituloEs,
    tituloEn,
    tituloVa,
    descripcionEs,
    descripcionEn,
    descripcionVa,
    videoUrl,   
    
  });


  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Ámbito
        </button>
      );
    }
    //if is update && logged user included as IP
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() => deleteIt(AMBITOS, id, ROUTES.Ambitos.all, source)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  // const selectStaffIds = () => {
  //   let staffIds: number[] = [];
  //   chosenStaff.map(({ id }: any) => staffIds.push(id));

  //   return staffIds;
  // };

  // // HANDLE STAFF
  // const addStaff = (staff: any) => {
  //   staff = JSON.parse(staff);
  //   setChosenStaff((state) =>
  //     produce(state, (drafState) => {
  //       drafState.push(staff);
  //     })
  //   );
  //   setStaff((state) =>
  //     produce(state, (drafState) =>
  //       drafState.filter(({ id }) => id !== staff.id)
  //     )
  //   );
  // };

  // const removeStaff = (staff: any) => {
  //   //remove staff from list
  //   setChosenStaff((state) =>
  //     produce(state, (drafState) =>
  //       drafState.filter(({ id }) => id !== staff.id)
  //     )
  //   );
  //   // add staff to list
  //   setStaff((state) =>
  //     produce(state, (drafState) => {
  //       drafState.push(staff);
  //     })
  //   );
  // };


  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 2) && (
        <>
          {" "}
          <div className="container-fluid ">
            <div className="row">
              <div className="col d-flex justify-content-between">
                <div>
                  <h3>Ámbito</h3>
                </div>
                <div>{editDeleteButtons()}</div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className="form-row mt-2  d-flex flex-start">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setImage} image={image} />
            </div>
            <div className="col-6  d-flex flex-column  justify-content-center ">
              <small>*Nombre español</small>
              <input
                type="text"
                className="form-control"
                placeholder="Nombre español"
                value={tituloEs}
                onChange={({ target: { value } }) => {
                  setTituloEs(value);
                }}
                disabled={!allowedEdit}
              />
              <small className="mt-4">*Nombre inglés</small>
              <input
                type="text"
                className="form-control "
                placeholder="Nombre inglés"
                value={tituloEn ? tituloEn : ""}
                onChange={({ target: { value } }) => {
                  setTituloEn(value);
                }}
                disabled={!allowedEdit}
              />
              <small className="mt-4">*Nombre valenciano</small>
              <input
                type="text"
                className="form-control "
                placeholder="Nombre valenciano"
                value={tituloVa ? tituloVa : ""}
                onChange={({ target: { value } }) => {
                  setTituloVa(value);
                }}
                disabled={!allowedEdit}
              />
            </div>
          </div>
            {/* <small>Participantes</small>
          <div className="col">       
            {staff?.map((staff: any) => (
              <span
                key={staff.id}
                style={{ cursor: "pointer" }}
                className="badge badge-info badge-blue-color mr-1 mt-3  "
                // onClick={() => removeStaff(staff)}
              >
                {staff.nombre} {staff.apellidos} 
              </span>
            ))}
          </div> */}
          {(isCreate || allowedEdit) && (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en español</small>
                  <CKEditor
                    initData={descripcionEs}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setDescripcionEs(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>

              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en inglés</small>
                  <CKEditor
                    initData={descripcionEn}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setDescripcionEn(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en valencianos</small>
                  <CKEditor
                    initData={descripcionVa}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setDescripcionVa(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

